<template>
<div >
   
  
    
 

   
  <b-modal v-if="!modaldel" id="modal-delete"  hide-footer title="Supprimer">
      <form @submit="deletecategory(user.id)">
    <p class="my-4">Voulez vous supprimer</p>
     <hr class="my-4" />
    <center>
       <b-btn type="button" style="background-color:#c2b59b;color:#fff" >non</b-btn>
      <b-btn type="submit"   style="background-color:#c2b59b;color:#fff" >oui</b-btn>
   
    </center> 
    </form>
  </b-modal>
   
    
   
   
</div>
</template>
<script>

import { setToken, del } from "@/mixins/api";
export default {
     name: 'ModalDeleteCategorie',
      components: {

  },
  
    data() {
      
      return {

        modaldel:false,
        user:{
          id:'',
          
        },
        userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
      
      }
    },
      methods:{
        getCategorie(data)
        {
          console.log(data)
          this.user=data;
        },
           deletecategory(id){
         
  del("category/"+id,this.user)
                 .then(resp => {
         
        this.output = resp.data.data;
        this.modaldel=false
          this.$emit('categorieadd')
    }); this.modaldel = true;    
      },
      },
    
       mounted() {
    setToken(this.userToken);
    //this.loadData();
    
  },
}
</script>
                        